export default class LineageName {

  constructor(name) {
    this.name = name;
    let tokens = name.split('.');
    this.major = tokens[0].toUpperCase();
    this.minors = tokens.slice(1).map(n=>n === '_' || n.toLowerCase() === 'x' ? 'x' : parseInt(n));
    this.depth = this.minors.length;
    this.label = [this.major].concat(this.minors).join('.');
  }
}

LineageName.sort = (a, b)=>{
  let diff = a.major === b.major ? 0
    : a.major.length < b.major.length ? -1
      : a.major.length > b.major.length ? 1
        : a.major < b.major ? -1
          : 1;
  if (diff === 0) {
    let l = Math.min(a.depth, b.depth),
      i = 0;
    while (diff === 0 && i < l) {
      diff = a.minors[i] - b.minors[i];
      i++;
    }
    if (diff === 0) {
      diff = a.depth - b.depth;
    }
  }
  return diff;
};
